/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */


export const trees: { [key: string]: string } = {
  PasswordReset: 'pwc_reset_password',
  login: 'pwc-login',
  samlLogin: 'pwc-saml-login',
 
};

export const ciam_trees: { [key: string]: string }={
    login: 'ciam-login',
    PasswordReset: 'ciam-reset-password',
    PasswordSet:'ciam-set-password',
     samlLogin: 'ciam-saml-login',
}


const hostPWC = import.meta.env.VITE_HOST_PWC;
const hostCIAM =import.meta.env.VITE_HOST_CIAM;

export const configOptionsPWC = {
  clientId: 'dashboardAppClient',
  redirectUri: hostPWC + '/pwc/pageNotFound',
  scope: 'openid email profile fr:idm:*',
  serverConfig: {
    baseUrl: hostPWC + '/login/',
    timeout: 60000
  },
  support: 'legacy',
  realmPath: 'PWC',
  tree: 'pwc_login',
  host:hostPWC
};


export const configOptionsCIAM = {
  clientId: 'dashboardAppClient',
  redirectUri: hostCIAM + '/pwc/pageNotFound',
  scope: 'openid email profile fr:idm:*',
  serverConfig: {
    baseUrl: hostCIAM + '/login/',
    timeout: 60000
  },
  support: 'legacy',
  realmPath: 'CIAM',
  tree: 'pwc_login',
  host:hostCIAM
};
export const idmConfigOptionsPWC = {
  baseUrl: hostPWC + '/openidm/'
};

export const idmConfigOptionsCIAM = {
  baseUrl : hostCIAM + '/openidm/'
}

